<template>
  <section>
    <b-dropdown
      aria-role="list"
      class="local-lm-filters local-lm-fix--min-width"
      v-model="selectedOption"
      @active-change="sort"
    >
      <button
        class="button"
        type="button"
        slot="trigger"
      >
        <div class="local-lm-filters--placeholder">
          <template>
            <span
              v-if="!selectedOption"
              v-t="$t('PartnerTableFilter.title')"
            />
            <span
              v-if="selectedOption"
              v-t="$t(`PartnerTableFilter.${selectedOption}`).toUpperCase()"
            />
          </template>
          <b-icon
            icon="chevron-down"
          />
        </div>
      </button>
      <b-dropdown-item
        v-for="(availableFilter, index) in availableFilters"
        :key="index"
        :value="availableFilter"
      >
        {{ $t(`PartnerTableFilter.${availableFilter}`) | upperCase }}
      </b-dropdown-item>
    </b-dropdown>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'PartnerTableFilter',
  computed: {
    ...mapGetters('filters', [
      'availableFilters'
    ]),
    type () {
      return this.$attrs.type
    }
  },
  mounted () {
    this.$store.dispatch('filters/getAvailableFilters', this.type)

    this.$eventBus.$on('cleanFilters', () => {
      this.selectedOption = null
    })
  },
  data () {
    return {
      selectedOption: null
    }
  },
  methods: {
    sort () {
      if (!this.selectedOption) return

      const filters = this.$store.getters['filters/filtersSelected']

      if (!filters || (filters && filters.sort !== this.selectedOption)) {
        this.$store.dispatch('filters/setSort', this.selectedOption)
        this.$eventBus.$emit('getOrders')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filters/PartnerTableFilter.vue